import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { BaseCell, BaseHeader } from './Column';
import { FlightStatusBadge } from '../../../../shared/status/ui/FlightStatusBadge';
import { Responsive } from '../../../../../../ui';

interface IProps {
	status: string;
}

const styles = css`
	display: flex;
	justify-content: flex-start;
`;

export const StyledHeader = styled(BaseHeader)`
	${styles};
`;

export const StyledCell = styled(BaseCell)`
	${styles};
	padding-top: 0;
	padding-bottom: 0;

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		padding-right: 0;
	}
`;

export function Header() {
	return <StyledHeader css={styles}>Status</StyledHeader>;
}

export function Cell({ status }: IProps) {
	return (
		<StyledCell css={styles}>
			<FlightStatusBadge status={status} />
		</StyledCell>
	);
}
